export default "ddf96f435d49fb82.svg"